import Button from 'components/Button';
import Checkbox from 'components/Checkbox';
import FormActionGroup from 'components/FormActionGroup';
import Modal from 'components/Modal';
import Typography from 'components/Typography';
import {useHistory} from 'react-router-dom';
import styles from './MessageModal.module.scss';
import {PropsWithChildren} from 'react';
import {SelectOption} from 'types';
import CreatableSelect from 'components/CreatableSelect';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  username: string;
  handleChannelChange: (name: string, isChecked: boolean) => void;
  sendChannels: {
    sms: boolean;
    email: boolean;
    push: boolean;
  };
  sendMessage: () => void;
  messageTemplates?: SelectOption[];
  selectedTemplate?: SelectOption;
  onSelect: (option: SelectOption) => void;
} & PropsWithChildren<unknown>;

function MessageModal({
  isOpen,
  onClose,
  username,
  sendChannels,
  handleChannelChange,
  children,
  sendMessage,
  messageTemplates,
  onSelect,
  selectedTemplate,
}: Props) {
  const {push} = useHistory();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onRequestClose={onClose}
      className={styles.smsModal}
    >
      <Typography variant="h2">Send message to {username}</Typography>
      <div className={styles.checkboxContainer}>
        <label style={{display: 'flex', alignItems: 'center', gap: 6}}>
          <Checkbox
            name="sms"
            className={styles.checkbox}
            checked={sendChannels.sms}
            onChange={({target: {name, checked}}) =>
              handleChannelChange(name, checked)
            }
          />
          <span>SMS</span>
        </label>
        <label style={{display: 'flex', alignItems: 'center', gap: 6}}>
          <Checkbox
            name="email"
            className={styles.checkbox}
            checked={sendChannels.email}
            onChange={({target: {name, checked}}) =>
              handleChannelChange(name, checked)
            }
          />
          <span>Email</span>
        </label>
        <label style={{display: 'flex', alignItems: 'center', gap: 6}}>
          <Checkbox
            name="push"
            className={styles.checkbox}
            checked={sendChannels.push}
            onChange={({target: {name, checked}}) =>
              handleChannelChange(name, checked)
            }
          />
          <span>Push</span>
        </label>
      </div>
      {/* Textarea component for entering the message text */}
      {children}

      <div className={styles.label}>
        <div>Template</div>
      </div>
      <CreatableSelect
        className={styles.templateSelect}
        placeholder="Search For Template"
        components={{
          DropdownIndicator: () => null,
        }}
        options={messageTemplates}
        value={selectedTemplate}
        onChange={onSelect as any}
        onCreateOption={() => {
          push('/settings/templates/create');
        }}
      />

      <FormActionGroup className={styles.buttonWrap}>
        <Button onClick={sendMessage} color="blue">
          Send
        </Button>
      </FormActionGroup>
    </Modal>
  );
}
export default MessageModal;
